<div class="d-flex justify-content-between align-items-center">
  <h6>Sanction the Proposal</h6>

  <!-- Cancel Button -->
  <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
</div>

<div class="row">
  <form action="" [formGroup]="sanctionLoanForm" (ngSubmit)="submitsanctionLoan(sanctionLoanForm.value)">
    <div class="col-12 d-flex flex-wrap">

      <!-- Loan Type -->
      <div class="col-md-12">
        <mat-form-field appearance="outline" class="example-full-width w-100 me-4">
          <mat-label>Loan Type</mat-label>
          <mat-select formControlName="loanType" required>
            <mat-option *ngFor="let type of loanType" [value]="type.id">
              {{ type.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Loan A/C No. -->
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="example-full-width w-100 me-4">
          <mat-label>Loan A/C No.</mat-label>
          <input type="text" matInput formControlName="loanAccountNumber" required>
        </mat-form-field>
      </div>

      <!-- Sanctioned Amount -->
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="example-full-width w-100 me-2">
          <mat-label>Sanctioned Amount</mat-label>
          <input type="number" matInput formControlName="sanctionAmount" required>
          <mat-error *ngIf="sanctionLoanForm.get('sanctionAmount').hasError('max')">
            Limit reached. Only ₹20 Lakh allowed.
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Sanctioned Date -->
      <div class="col-md-6 mb-3">
        <mat-form-field appearance="outline" class="example-full-width w-100 me-2">
          <mat-label>Sanctioned Date</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            formControlName="sanctionDate"
            [min]="minDate"
            [matDatepickerFilter]="dateFilter"
            required>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="sanctionLoanForm.get('sanctionDate')?.invalid">
            Please select a valid date between {{ minDate | date: 'shortDate' }} and {{ maxDate | date: 'shortDate' }}.
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Interest Rate -->
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="example-full-width w-100 me-4">
          <mat-label>Interest Rate</mat-label>
          <input type="text" matInput formControlName="interestRate" required>
          <mat-error *ngIf="sanctionLoanForm.get('interestRate')?.hasError('required')">
            Interest rate is required.
          </mat-error>
          <mat-error *ngIf="sanctionLoanForm.get('interestRate')?.hasError('pattern')">
            Please enter a valid interest rate with up to two decimal places.
          </mat-error>
          <mat-error *ngIf="sanctionLoanForm.get('interestRate')?.hasError('min')">
            Interest rate cannot be below 0.
          </mat-error>
          <mat-error *ngIf="sanctionLoanForm.get('interestRate')?.hasError('max')">
            Interest rate cannot exceed 99.99.
          </mat-error>
        </mat-form-field>
      </div>


      <!-- DP Limit -->
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="example-full-width w-100">
          <mat-label>DP Limit</mat-label>
          <input type="text" pattern="\d*" minlength="0" maxlength="7" matInput formControlName="dpLimit">
        </mat-form-field>
      </div>

      <!-- Conditional Fields -->
      <ng-container *ngIf="sanctionLoanForm.controls['loanType'].value == 2">
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="example-full-width w-100 me-2">
            <mat-label>Installment Number</mat-label>
            <input type="number" matInput formControlName="installmentNumber">
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="example-full-width w-100 me-2">
            <mat-label>Disbursed Amount</mat-label>
            <input type="number" matInput formControlName="disbursedAmount">
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="example-full-width w-100 me-2">
            <mat-label>EMI</mat-label>
            <input type="number" matInput formControlName="emi">
          </mat-form-field>
        </div>
      </ng-container>
    </div>

    <div class="col-12 text-end">
      <button class="btn add-btn" [disabled]="sanctionLoanForm?.status == 'INVALID'">SUBMIT</button>
    </div>
  </form>
</div>
